/**
 * Raffica di clic: tiene solo quelli degli ultimi `windowMs` e dice se sono almeno `count`. Dopo una raffica
 * riuscita riparte da zero, così il sesto clic non la fa scattare di nuovo.
 */
export function registerClick(clicks: readonly number[], now: number, count: number, windowMs: number): { clicks: number[]; isBurst: boolean } {
  const recent = [...clicks.filter((t) => now - t < windowMs), now]
  return recent.length >= count ? { clicks: [], isBurst: true } : { clicks: recent, isBurst: false }
}
